module.exports = __webpack_public_path__ + "static/media/relatedPending.871a6835.svg";